import { format, parse, isValid, parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export const normalizeDate = (input: Date | string): Date => {
  if (input instanceof Date) return input;

  const isoDate = parseISO(input);
  if (isValid(isoDate)) return isoDate;

  const customDate = parse(input, 'yyyy-dd-MM', new Date());
  if (isValid(customDate)) return customDate;

  throw new Error(`Invalid date format: ${input}`);
};

const getZonedDate = (date: Date, timezone?: string): Date => timezone ? toZonedTime(date, timezone) : date;

export const formatDate = (
  date: Date | string,
  formatStr: string,
  timezone?: string
): string => {
  const parsedDate = normalizeDate(date);
  const zonedDate = getZonedDate(parsedDate, timezone);
  return format(zonedDate, formatStr);
};

export const formatDateToDayMonthYear = (
  date: Date | string,
  timezone?: string
): string => formatDate(date, 'MM/dd/yyyy', timezone);

export const formatDateToYearMonthDayDate = (
  date: Date | string,
  timezone?: string
): string => formatDate(date, 'yyyy-dd-MM', timezone);